export const PAGES_CONFIG = {
  DASHBOARD: 'dashboard',
  REQUESTS: 'requests',
  REPORTS: 'reports',
  HELP: 'help',
  VERSIONS: 'versions',
  ERROR: 'error',
  ERROR_AUTH: 'error-authorization',
  SUBSTITUTES: 'substitutes',
  APPROVALS: 'approvals',
};

export enum ERRORS {
  auth = 'auth',
  permission = 'permission',
  notFound = '404',
  translationLoadError = 'translation',
  serviceUnavailable = 'service_unavailable'
}
